import { useMemo } from 'react'
import {
  conditionNameToDiseaseMapping,
  therapyAreaMapping,
} from '../utils/helpers/common'
import { useSelector } from 'react-redux'

const useGetLoggedInUser = () => {
  const { userDetails } = useSelector((state) => state.auth)
  const source = useMemo(() => {
    return userDetails?.data?.patient_meta_info?.source || 'GoodFlip'
  }, [userDetails])

  const mappedConditionName = conditionNameToDiseaseMapping('')
  const mappedTherapyArea = therapyAreaMapping('metabolism')
  return {
    source,
    userDetails: userDetails?.data,
    condition_name: 'others',
    therapy_area: 'metabolism',
    mappedConditionName,
    mappedTherapyArea,
  }
}

export default useGetLoggedInUser
